import React, { Fragment } from 'react';

import { HeaderContacts } from './HeaderContacts';
import { BodyContacts } from './BodyContacts';
import { FooterContacts } from './FooterContacts';
import { baseImgUrl } from './constants';

const ContactsLP = () => {
  return (
    <Fragment>
      <HeaderContacts baseImgUrl={baseImgUrl} />
      <BodyContacts baseImgUrl={baseImgUrl} />
      <FooterContacts baseImgUrl={baseImgUrl} />
    </Fragment>
  );
};

export default ContactsLP;
